var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.item.text && _vm.item.href)?_c('smart-link',{attrs:{"to":_vm.item.href,"data-gtm":"TopNav.Link"}},[_c('btn',{attrs:{"type":"cta","theme":"utility"}},[_vm._v(_vm._s(_vm.item.text))])],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }